const mainVar = {
  server: 'https://bertello.herokuapp.com'
  // server: 'http://localhost:3000'
}


export default mainVar